import { Drawer, useMediaQuery } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../store/store";
import {
  affiliatesFilterSidebarSelector,
  setAffiliatesFilterSidebarClose,
} from "../../../../store/features/profileSlice";
import { useTranslation } from "react-i18next";
import { AffiliatesDateRangePicker } from "../elements/AffiliatesDateRangePicker";
import { IDateRange } from "../../../../store/api/affiliatesProfileApiSlice";
import { AffiliatesStatusSelect } from "../elements/AffiliatesStatusSelect";
import BlueCross from "../../../../assets/profile/icons/blueCross.svg";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { DEFAULT_DATE_RANGE, DEFAULT_LEAD_STATUS } from "../contants";

export const AffiliatesFilterMobileSidebar = ({
  initLeadStatus,
  onLeadStatusChange,
  dateRange,
  setDateRange,
}: {
  initLeadStatus: string;
  onLeadStatusChange: React.Dispatch<React.SetStateAction<string>>;
  dateRange: IDateRange;
  setDateRange: React.Dispatch<React.SetStateAction<IDateRange>>;
}) => {
  const { i18n, t } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();
  const langTheme = useLanguageTheme();
  const is970px = useMediaQuery("(max-width: 970px)");

  const openSideNav = useSelector(affiliatesFilterSidebarSelector);

  React.useEffect(() => {
    if (!is970px) {
      dispatch(setAffiliatesFilterSidebarClose());
    }
  }, [is970px]);

  const handleClearFilters = () => {
    onLeadStatusChange(DEFAULT_LEAD_STATUS);
    setDateRange(DEFAULT_DATE_RANGE);
  };

  const content = (
    <div
      className="affiliates-filter-mobile-sidebar-container"
      style={{
        fontFamily: langTheme.mainFont(),
      }}
    >
      <div className="affiliates-filter-mobile-sidebar-header-container">
        <div className="affiliates-filter-mobile-sidebar-filters-title">
          {t("filters")}
        </div>
        <img
          style={{
            cursor: "pointer",
          }}
          src={BlueCross}
          onClick={() => dispatch(setAffiliatesFilterSidebarClose())}
        />
      </div>
      <div className="affiliates-filter-mobile-sidebar-filters-wrapper">
        <AffiliatesDateRangePicker
          dateRange={dateRange}
          setDateRange={setDateRange}
        />

        <AffiliatesStatusSelect
          initLeadStatus={initLeadStatus}
          onLeadStatusChange={onLeadStatusChange}
        />
      </div>

      <div className="affiliates-filter-mobile-sidebar-btns-container">
        <div
          className="affiliates-filter-mobile-sidebar-apply"
          onClick={() => dispatch(setAffiliatesFilterSidebarClose())}
        >
          {t("apply")}
        </div>
        <div
          className="affiliates-filter-mobile-sidebar-clear"
          onClick={handleClearFilters}
        >
          {t("clear")}
        </div>
      </div>
    </div>
  );

  return (
    <Drawer
      transitionDuration={400}
      anchor="top"
      open={openSideNav}
      onClose={() => dispatch(setAffiliatesFilterSidebarClose())}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 1)",
          width: "100%",
          direction: i18n.dir(),
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "transparent",
        },
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};
